import { useState, useLayoutEffect, MutableRefObject } from 'react';

/*
*   Определяем переполнение контента в блоке
*/

export const useIsOverflow = (
    ref: MutableRefObject<HTMLDivElement>,
    callback: (
        hasOverflow: boolean | undefined,
        currentEl?: any
    ) => void,
): boolean | undefined => {
    const [isOverflow, setIsOverflow] = useState<boolean | undefined>(undefined);

    useLayoutEffect(() => {
        const { current } = ref;

        const trigger = () => {
            const hasOverflow = current.scrollHeight > current.clientHeight;

            setIsOverflow(hasOverflow);

            if (callback) callback(hasOverflow, current);
        };

        if (current) {
            if ('ResizeObserver' in window) {
                new ResizeObserver(trigger).observe(current);
            }

            trigger();
        }
    }, [callback, ref]);

    return isOverflow;
};